import { createSelector } from 'reselect';
import { RootState } from '../../../../config/store/rootReducer';
import { Modules } from '../../types/modules';

const getAvailableModules = (state: RootState): Modules => state.security.modules;

export const makeGetAvailableModules = () => createSelector(getAvailableModules, (modules: Modules) => modules);
